import { X } from "@phosphor-icons/react"
import { IconButton } from "@tokenterminal/core/ui/button/IconButton"

export const FilterTypeText = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="h-full flex items-center px-2 gap-1 text-sm whitespace-nowrap">
      {children}
    </div>
  )
}

export const SelectedFilterBase = ({
  filterTypeSlot,
  operatorSlot,
  valueSlot,
  handleRemoveFilter,
}: {
  filterTypeSlot: React.ReactNode
  operatorSlot: React.ReactNode
  valueSlot: React.ReactNode
  handleRemoveFilter: () => void
}) => {
  return (
    <div
      data-filter-group
      tabIndex={0}
      className="h-tt-small relative focus:outline-none focus-visible:outline-2 focus-visible:outline-sky-500 focus-visible:outline-offset-[3px] max-w-full rounded-lg"
      onKeyDown={(e) => {
        if (e.key === "Backspace" && e.target === e.currentTarget) {
          handleRemoveFilter()
        }
      }}
    >
      <div className="h-full flex flex-row items-stretch justify-between relative z-[1] rounded-lg bg-white dark:bg-neutral-900 text-fg-default border border-solid border-neutral-200 dark:border-neutral-800 shadow-[0_1px_5px_rgba(0,0,0,.025)] dark:shadow-[0_1px_2px_rgba(0,0,0,.1)]">
        <div className="h-full">{filterTypeSlot}</div>
        <div className="border-l border-solid border-l-border-default h-full">
          {operatorSlot}
        </div>
        <div className="border-l border-solid border-l-border-default h-full">
          {valueSlot}
        </div>
        <div className="border-l border-solid border-l-border-default block">
          <IconButton
            icon={X}
            label="Remove filter"
            variant="ghost"
            size="small"
            className="!w-7 !h-full !rounded-tr-[7px] !rounded-br-[7px] text-fg-secondary"
            onPress={handleRemoveFilter}
            style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
          />
        </div>
      </div>
    </div>
  )
}
